import { render, staticRenderFns } from "./ModuleLoaderSP.vue?vue&type=template&id=42e1d71e&"
import script from "./ModuleLoaderSP.vue?vue&type=script&lang=js&"
export * from "./ModuleLoaderSP.vue?vue&type=script&lang=js&"
import style0 from "./ModuleLoaderSP.vue?vue&type=style&index=0&id=42e1d71e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports